const Layout = r => require(['@/pages/PageLayout'], r);

// 帮助
const Tutorial = r => require(["@/pages/new-home-help"], r);

export default {
  path: "/new-home-help",
  component: Layout,
  redirect: "/new-home-help/index",
  children: [
    {
      path: "/new-home-help/index",
      component: Tutorial
    }
  ]
};
